var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuperiorityBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 415,
    viewBox: "0 0 424 415",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.624 40.9276L12.0161 149.626C4.5814 153.911 0 161.839 0 170.42V391C0 404.255 10.7452 415 24 415H400C413.255 415 424 404.255 424 391V170.378C424 161.819 419.443 153.908 412.039 149.615L224.647 40.9592C217.221 36.6536 208.061 36.6415 200.624 40.9276Z",
    fill: "url(#paint0_linear_4126_8236)",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200.182 22.5403L11.5758 136.658C4.39018 141.006 0 148.794 0 157.192V391C0 404.255 10.7452 415 24 415H400C413.255 415 424 404.255 424 391V157.15C424 148.774 419.634 141.004 412.48 136.649L225.086 22.5738C217.441 17.9197 207.84 17.9067 200.182 22.5403Z",
    fill: "url(#paint1_linear_4126_8236)",
    fillOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199.757 4.16785L11.152 123.706C4.20805 128.107 0 135.756 0 143.977V391C0 404.255 10.7452 415 24 415H400C413.255 415 424 404.255 424 391V143.934C424 135.736 419.816 128.106 412.904 123.698L225.509 4.20329C217.659 -0.802601 207.621 -0.816419 199.757 4.16785Z",
    fill: "url(#paint2_linear_4126_8236)",
    fillOpacity: 0.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4126_8236",
    x1: 212,
    y1: 34,
    x2: 212,
    y2: 415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7FFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF66",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4126_8236",
    x1: 212,
    y1: 15,
    x2: 212,
    y2: 415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7FFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF66",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4126_8236",
    x1: 212,
    y1: -4,
    x2: 212,
    y2: 415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7FFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF66",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperiorityBg);
export default __webpack_public_path__ + "static/media/superiority-bg.f3154758387123431b461a53d9bda7bb.svg";
export { ForwardRef as ReactComponent };